import { emptyDisposable } from 'common/barrels/core';
import { Observable } from 'common/barrels/rx';

import { ContainerControl } from 'runtime/controls/containercontrol';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';
import { applyBindings } from 'runtime/bindingengine';

import 'runtime/styles/controls/viewbox.less';

export class ViewBox extends ContainerControl {
    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.$element.addClass('control-container viewbox');

        this.subscriptions = emptyDisposable;

        applyBindings(this.$element.children(), this.fieldContext, this.eventAggregator, this.methods, this.values, this.resources, this, this.serializer);

        this.initialize();
    }

    focus() { }

    applyEnabledState(value: boolean) {
        this.propagateEnabledStateToChildElements(this.$element, this.writableAgnosticDerivedEnabledState());
    }

    resizeStream(): Observable<{}> {
        return this.stretches() ? this.container.resizeStream() : Observable.never();
    }
}

registerBinding('viewbox', ViewBox);